import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function createBlogPost(options = {}) {
  return function withContext(context) {
    const url = `${API_URL}blog/posts`;
    return _fetch(
      url,
      { withAuth: true },
      {
        method: 'POST',
        body: JSON.stringify(options.body),
        headers: {
          'Accept': 'application/json;charset=utf-8',
          'Content-Type': 'application/json;charset=utf-8'
        }
      }
    )(context);
  };
}
